import { render, staticRenderFns } from "./StockManage.vue?vue&type=template&id=1974ca4a&scoped=true&"
import script from "./StockManage.vue?vue&type=script&lang=js&"
export * from "./StockManage.vue?vue&type=script&lang=js&"
import style0 from "./StockManage.vue?vue&type=style&index=0&id=1974ca4a&scoped=true&lang=scss&"
import style1 from "./StockManage.vue?vue&type=style&index=1&id=1974ca4a&scoped=true&lang=css&"
import style2 from "./StockManage.vue?vue&type=style&index=2&id=1974ca4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1974ca4a",
  null
  
)

export default component.exports